import UNINITIALISED from "utils/uninitialised";
import UserActionTypes from "modules/user/constants/action_types";
import ActionTypes from "../constants/action_types";

export default function documentClausesReducer(state = UNINITIALISED, action) {
  switch (action.type) {
    case ActionTypes.DOCUMENT_CLAUSE_ADD.SUCCESS:
    case ActionTypes.DOCUMENT_CLAUSE_REVERT.SUCCESS:
    case ActionTypes.DOCUMENT_STATE_REVERT.SUCCESS:
    case ActionTypes.DOCUMENT_FETCH.SUCCESS:
    case ActionTypes.MATTER_DOCUMENT_FETCH.SUCCESS:
      return !action.payload.definitions ? state : action.payload.definitions;
    case ActionTypes.DOCUMENT_CLEAR.SUCCESS:
      return UNINITIALISED;
    case UserActionTypes.USER_LOGOUT.SUCCESS:
      return UNINITIALISED;
    default:
      return state;
  }
}
